import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store';
import 'simplebar/src/simplebar.css';
import AppRecording from './AppRecording';

const getVideoSlug = () => {
  const elm = document.getElementById("screenjar-demo-slug");
  return elm ? elm.value : "";
}
const requestSlug = getVideoSlug();
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {requestSlug !== '' ? <AppRecording requestSlug={requestSlug} /> : <App />}
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

